const umas4mConfig = window.$umas4m_config;
const proxy = umas4mConfig.proxy_url;
const is_wp = umas4mConfig.is_wp;
const rate_limit = umas4mConfig.rate_limit;
const token = umas4mConfig.dev_mode ? umas4mConfig.dev_nonce : document.getElementById('umas4m_nonce').value;

const callApi = (endpoint, method, params, bad_response = false) => {
	const url = is_wp ? proxy + '?action=umas4m_request' : proxy + endpoint;
	const data = {
		method: method,
		params: params,
		action: 'umas4m_request',
		nonce: token,
		endpoint: endpoint
	}
	const payload = {
		method: 'POST',
		mode: umas4mConfig.dev_mode ? 'cors' : 'same-origin',
		cache: 'no-cache',
		credentials: umas4mConfig.dev_mode ? 'include' : 'same-origin',
		headers: { 
			"X-UMAS4M-Proxy-Token": token,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	}

	return fetch(url, payload)
		.then(response =>
			response.json().then(json => {
				if (!response.ok) {
					return Promise.reject(json)
				}
				return json;
				// return Object.assign({}, json); // needed?
			}).catch((err) => { 
				const contentType = response.headers.get('content-type');
				let msg = bad_response ? bad_response : response.statusText;
				if (contentType && contentType.includes('application/json') && err.message) {
					msg = err.message;
				} 
				return Promise.reject({message: msg +  ' (error code: ' + response.status + ')'  }) 
			})
		)
}

// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = 'Call API'

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
export default store => next => async(action) => {

	const callAPI = action[CALL_API]
	if (typeof callAPI === 'undefined') {
		return next(action)
	}

	let { endpoint, method, params, bad_response, add_data } = callAPI
	const { types } = callAPI

	if (typeof endpoint === 'function') {
		endpoint = endpoint(store.getState())
	}

	if (typeof endpoint !== 'string') {
		throw new Error('Specify a string endpoint URL.')
	}
	
	if (typeof method !== 'string'){
		method = 'POST';
	}
	
	if (typeof params !== 'object'){
		params = {}
	}
	
	if(typeof add_data !== 'object'){
		add_data = null
	}

	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected an array of three action types.')
	}
	if (!types.every(type => typeof type === 'string')) {
		throw new Error('Expected action types to be strings.')
	}

	const actionWith = data => {
		const finalAction = Object.assign({}, action, data)
		delete finalAction[CALL_API]
		return finalAction
	}
	
	const [ requestType, successType, failureType ] = types
	next(actionWith({ type: requestType, extra: add_data }))
	
	let alreadySending = store.getState().apiSending;
	if(alreadySending >= rate_limit){
		// A queue might be better, but let's see how we go with a simple throttle
		console.log('Rate limit reached, throttling request', endpoint, alreadySending);
		while(alreadySending >= rate_limit){
			console.log('Waiting 100ms', endpoint, alreadySending)
			await new Promise(r => setTimeout(r, 100));
			alreadySending = store.getState().apiSending;
		}
		console.log('Proceeding with request', endpoint, alreadySending);
	}
	next(actionWith({ type: 'SET_SENDING', response: true }))
	
	return callApi(endpoint, method, params, bad_response).then(
		response => next(actionWith({
			response,
			extra: add_data,
			type: successType
		})),
		error => next(actionWith({
			type: failureType,
			extra: add_data,
			error: error.message || bad_response
		}))
	).finally(
		() => next(actionWith({ 
			type: 'SET_SENDING', 
			response: false 
		}))
	) 
}